import { useState } from 'react';

interface NavbarProps {
  isScrolled: boolean;
}

export default function Navbar({ isScrolled }: NavbarProps) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const scrollToSection = (id: string) => {
    setIsMobileMenuOpen(false);
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 sm:h-20">
          <div className="flex items-center gap-2 sm:gap-3">
            <div className="h-10 w-10 sm:h-12 sm:w-12 rounded-full overflow-hidden bg-transparent flex-shrink-0">
              <img
                src="https://static.readdy.ai/image/fea1a1a51237cd5b41d6d3275d2c0f20/5b38540b3234526a2f26206e289bc6d5.png"
                alt="Chef Ziad Logo"
                className="h-full w-full object-cover"
                style={{ mixBlendMode: 'multiply' }}
              />
            </div>
            <span
              className={`font-serif text-lg sm:text-xl md:text-2xl font-bold transition-colors ${
                isScrolled ? 'text-gray-900' : 'text-white'
              }`}
            >
              Chef Ziad
            </span>
          </div>

          {/* Desktop Menu */}
          <div className="hidden lg:flex items-center gap-8">
            <button
              onClick={() => scrollToSection('home')}
              className={`text-sm font-light tracking-wide transition-colors cursor-pointer ${
                isScrolled
                  ? 'text-gray-700 hover:text-[#C9A961]'
                  : 'text-white hover:text-[#C9A961]'
              }`}
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className={`text-sm font-light tracking-wide transition-colors cursor-pointer ${
                isScrolled
                  ? 'text-gray-700 hover:text-[#C9A961]'
                  : 'text-white hover:text-[#C9A961]'
              }`}
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('menu')}
              className={`text-sm font-light tracking-wide transition-colors cursor-pointer ${
                isScrolled
                  ? 'text-gray-700 hover:text-[#C9A961]'
                  : 'text-white hover:text-[#C9A961]'
              }`}
            >
              Menu
            </button>
            <button
              onClick={() => scrollToSection('portfolio')}
              className={`text-sm font-light tracking-wide transition-colors cursor-pointer ${
                isScrolled
                  ? 'text-gray-700 hover:text-[#C9A961]'
                  : 'text-white hover:text-[#C9A961]'
              }`}
            >
              Portfolio
            </button>
            <button
              onClick={() => scrollToSection('catering')}
              className={`text-sm font-light tracking-wide transition-colors cursor-pointer ${
                isScrolled
                  ? 'text-gray-700 hover:text-[#C9A961]'
                  : 'text-white hover:text-[#C9A961]'
              }`}
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="px-6 py-2.5 bg-[#C9A961] text-white rounded-lg text-sm font-medium tracking-wide transition-all hover:bg-[#B89851] hover:shadow-lg whitespace-nowrap cursor-pointer"
            >
              Contact
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`lg:hidden w-10 h-10 flex items-center justify-center transition-colors ${
              isScrolled ? 'text-gray-900' : 'text-white'
            }`}
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-200 shadow-lg">
          <div className="px-4 py-4 space-y-3">
            <button
              onClick={() => scrollToSection('home')}
              className="block w-full text-left px-4 py-2.5 text-gray-700 hover:bg-gray-50 hover:text-[#C9A961] rounded-lg text-sm font-light transition-colors cursor-pointer"
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="block w-full text-left px-4 py-2.5 text-gray-700 hover:bg-gray-50 hover:text-[#C9A961] rounded-lg text-sm font-light transition-colors cursor-pointer"
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('menu')}
              className="block w-full text-left px-4 py-2.5 text-gray-700 hover:bg-gray-50 hover:text-[#C9A961] rounded-lg text-sm font-light transition-colors cursor-pointer"
            >
              Menu
            </button>
            <button
              onClick={() => scrollToSection('portfolio')}
              className="block w-full text-left px-4 py-2.5 text-gray-700 hover:bg-gray-50 hover:text-[#C9A961] rounded-lg text-sm font-light transition-colors cursor-pointer"
            >
              Portfolio
            </button>
            <button
              onClick={() => scrollToSection('catering')}
              className="block w-full text-left px-4 py-2.5 text-gray-700 hover:bg-gray-50 hover:text-[#C9A961] rounded-lg text-sm font-light transition-colors cursor-pointer"
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="block w-full px-4 py-2.5 bg-[#C9A961] text-white rounded-lg text-sm font-medium tracking-wide transition-all hover:bg-[#B89851] cursor-pointer text-center"
            >
              Contact
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}
